/* eslint-disable react-hooks/exhaustive-deps */
//#region Styles
import { ButtonLink } from "components/styles";
//#endregion
//#region Components
import DialogChangeHistory from "./DialogChangeHistory/DialogChangeHistory";
//#endregion
//#region Utils
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
//#endregion

const ChangeHistory = ({
    spaceChangeHistory
}) => {
    const dialogShow = useShowDialogAlert();
    return (
        <>
            <ButtonLink
                margin="0 10px"
                onClick={async () => {
                    await spaceChangeHistory.fill();
                    dialogShow.set(true);
                }}>
                Ver historial de cambios
            </ButtonLink>
            <DialogChangeHistory
                dialogShow={dialogShow}
                changeHistory={spaceChangeHistory.value} />
        </>
    );
}

export default ChangeHistory;